import createSvgIcon from "./utils/create_icon"

const PlayFill = createSvgIcon(<path clipRule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7.507-3.87a1 1 0 0 1 1.008.013l5 3a1 1 0 0 1 0 1.714l-5 3A1 1 0 0 1 9 15V9a1 1 0 0 1 .507-.87z" fill="currentColor" fillRule="evenodd" />, "PlayFill")
export default PlayFill
